// extracted by mini-css-extract-plugin
module.exports = {"container":"e_o5","sizeMedium":"e_p5","sizeSmall":"e_q5","icon":"e_r5"};